import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';

function App() {


  const setVh = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }

  useEffect(()=>{
    setVh()

    function onResize(){
      setVh()
    }

    window.addEventListener('resize', onResize)

  },[])

  const [page, setPage] = useState(0)

  const questionsList = [
    {
      q:[`J'ai eu un empêchement`, `Je ne peux pas te rencontrer aujourdhui`],
      a : [{type: "I", text: "Zut, tant pis (oh oui!!)"},
          {type: "E", text :"Zut, tant pis (qui je vois d'autre ?)"}]
    },
    {
      q:['Tu as été très occupé cette semaine', 'tu vas faire quoi pendant le week-end ?'],
      a : [{type: "I", text: "J'ai été tellement fatiguée que j'ai besoin de me reposer à la maison."},
          {type: "E", text :"J'ai été très occupé, j'ai besoin de sortir et de prendre l'aire."}]
    },
    {
      q:['Le propriétaire de mon café préféré a fait semblant de me connaître'],
      a : [{type: "I", text: "(Je devrais plus venir ici maintenant)"},
          {type: "E", text :"(Je devrais revenir plus souvent)"}]
    },
    {
      q:['Qui est plus important quand tu écoutes une chanson ?'],
      a : [{type: "S", text: "Mélodies"},
          {type: "N", text :"Paroles"}]
    },
    {
      q:[`Qu'est-ce qui te vient à l'esprit quand tu penses aux « pommes » ?`],
      a : [{type: "S", text: "Il est rouge. Délicieux. ronde"},
          {type: "N", text :"Le logo de l'iPhone ahaha, je me rappelle aussi Blanche-Neige."}]
    },
    {
      q:[`Qu'est ce que tu veux manger aujourd'hui ?`],
      a : [{type: "S", text: "Mmm, des pâtes?"},
          {type: "N", text :"Des pâtes ? Ah! J'ai envie de manger un riz au curry pour le dîner!"}]
    },
    {
      q:['Je me sens vraiment déprimé ces derniers temps', 'Donc je pars en voyage.'],
      a : [{type: "F", text: "Qu'est-ce qui se passe ?"},
          {type: "T", text :"Où tu vas ?"}]
    },
    {
      q:['Que se passe-t-il quand nous partageons notre peine ?'],
      a : [{type: "F", text: "chagrin divisé par deux."},
          {type: "T", text :"Ce serait deux personnes tristes"}]
    },
    {
      q:[`J'ai échoué à l'examen !`],
      a : [{type: "F", text: "ohh.. J'imagien que tu es bouleversée."},
          {type: "T", text :"Quel examen? Tu as échoué gravement?"}]
    },
    {
      q:['Combien tu as de messages non lus ?'],
      a : [{type: "P", text: "Plus de 10"},
          {type: "J", text :"0 à 9"}]
    },
    {
      q:['Tu as planifié ton itinéraire ?'],
      a : [{type: "P", text: "Oui, allons manger une pizza, et puis jouer dans l'océan, et puis aller dans un café."},
          {type: "J", text :"Rencontrons à 7h30, et puis pizzeria à 8h, et puis musée à 9h, plage à 11h, café à 12h..."}]
    },
    {
      q:[`L'examen est dans deux semaines.`],
      a : [{type: "P", text: "Il reste encore deux semaines avant l'examen !"},
          {type: "J", text :"Il reste que deux semaines avant l'examen."}]
    },
    {
      q:['Le test est fait, Tu veux voir les résultats ? '],
      a : [{type: "", text: "Voir résultats"}]
    },
  ]


  const [mbtiList, setMbtiList] = useState([
    {name: "I", count: 0}, 
    {name: "E", count: 0}, 
    {name: "S", count: 0}, 
    {name: "N", count: 0}, 
    {name: "F", count: 0}, 
    {name: "T", count: 0}, 
    {name: "P", count: 0}, 
    {name: "J", count: 0}, 
  ])

  const handleCkAnswer = (type ,index) => {
    let list = mbtiList
    for (let i = 0; i < list.length; i++) {
      if(list[i].name ===type){
        list[i].count = list[i].count +1
      }
      
    }

    setMbtiList(list)
    setPage(page+1)

    if(index+1 === questionsList.length){
      setMbti()
    }
  }

const [mbtiContents, setMbtiContents] = useState([])


  function setMbti(){
    // let mc = [
    //   {mbti: 'ENTP', contents : ['말을 잘해요','이상한 말을 자주 해요','혼자서도 잘 해요']},
    //   {mbti: 'INTP', contents : ['팩폭을 잘해요','감수성이 풍부해요','주관이 뚜렷해요']},
    //   {mbti: 'ESFJ', contents : ['남을 잘 챙겨요','눈치가 빨라요','새로운 사람과의 술자리를 좋아해요']},
    //   {mbti: 'ESTP', contents : ['손재주가 좋아요','리더십이 있어요','표현을 아끼지 않아요']},

    //   {mbti: 'ISFJ', contents : ['남 챙기는거 좋아해요','공감 잘해요','내가 싫은 건 남한테도 안 해요']},
    //   {mbti: 'ISTP', contents : ['효율적인 거 좋아해요','관찰력이 뛰어나요','기계조작 잘하고 좋아해요']},
    //   {mbti: 'ENFJ', contents : ['분위기 메이커에요','리액션을 잘 해요','남에게 싫은 소리를 잘 못해요']},
    //   {mbti: 'INFJ', contents : ['집돌이/집순이 성향이 강해요','사람을 보는 통찰력이 있어요.','자신만의 철학이 있어요']},

    //   {mbti: 'ENTJ', contents : ['직감이 좋은 편이에요','주변 사람을 잘 챙겨요','열등감이 없어요']},
    //   {mbti: 'INTJ', contents : ['혼자있는거 좋아해요','돈관리 잘해요','공상 많이해요']},
    //   {mbti: 'ENFP', contents : ['소통과 공감을 잘 해요','은근 독립적인 성격이에요','생각을 많이 해요']},
    //   {mbti: 'INFP', contents : ['MBTI정말 좋아해요','미룰 수 있는 건 끝까지 미뤄요','호불호가 명확해요']},

    //   {mbti: 'ESFP', contents : ['사교성이 좋아요','자존감이 높아요','상처 잘 받는데 또 잘 풀려요']},
    //   {mbti: 'ISFP', contents : ['노는 거 은근 좋아해요','근데 집에 있는 것도 좋아요','마이웨이 성향이 강해요']},
    //   {mbti: 'ESTJ', contents : ['호불호가 명확하고 단호해요','기억력이 좋아요','완벽주의자 기질이 있어요']},
    //   {mbti: 'ISTJ', contents : ['원리원칙적이에요','즉흥적인거 싫어해요','철벽을 잘 쳐요']},
    // ]

    let mc = [
      {mbti: 'ENTP', contents : [`Parler bien`,`Dire des choses étranges souvent`,`Se débrouiller bien seul`]},
      {mbti: 'INTP', contents : ['Donner des coups de gueule facilement','Avoir une grande sensibilité',`Avoir des opinions bien arrêtées`]},
      {mbti: 'ESFJ', contents : ['Prendre soin des autres',`Avoir le sens de l'observation`,`Apprécier les rencontres autour d'un verre avec de nouvelles personnes`]},
      {mbti: 'ESTP', contents : ['Être habile de ses mains','Avoir du leadership',`Ne pas hésiter à s'exprimer`]},

      {mbti: 'ISFJ', contents : ['Aimer prendre soin des autres',`Avoir de l'empathie`,`Ne pas faire aux autres ce que l'on n'aimerait pas qu'on nous fasse`]},
      {mbti: 'ISTP', contents : [`Apprécier l'efficacité`,`Avoir un sens de l'observation aiguisé`,'Être doué et aimer manipuler des machines']},
      {mbti: 'ENFJ', contents : [`Être un faiseur d'ambiance`,'Avoir de bonnes réactions','Avoir du mal à dire des choses désagréables aux autres']},
      {mbti: 'INFJ', contents : ['Avoir un penchant pour rester à la maison','Avoir un regard perspicace sur les gens','Avoir sa propre philosophie']},

      {mbti: 'ENTJ', contents : ['Avoir une bonne intuition','Prendre bien soin des gens autour de soi',`Ne pas avoir de complexe d'infériorité`]},
      {mbti: 'INTJ', contents : ['Apprécier être seul',`Bien gérer l'argent`,`Avoir beaucoup d'imaginaires`]},
      {mbti: 'ENFP', contents : [`Bien communiquer et avoir de l'empathie`,`Avoir une personnalité indépendante`,'Avoir beaucoup de réflexions']},
      {mbti: 'INFP', contents : ['Aimer beaucoup le MBTI',`Reporter jusqu'au bout ce qui peut être reporté`,`Avoir des goûts très marqués`]},

      {mbti: 'ESFP', contents : ['Aimer le social','Avoir une bonne estime de soi','Être blessé facilement mais se remettre vite']},
      {mbti: 'ISFP', contents : [`Aimer s'amuser`,`Apprécier rester à la maison aussi`,`Avoir un fort tempérament`]},
      {mbti: 'ESTJ', contents : ['Avoir des goûts tranchés et être catégorique','Avoir une bonne mémoire','Avoir des traits de perfectionniste']},
      {mbti: 'ISTJ', contents : ['Être régi par des principes',`Détester l'improvisation`,'Savoir bien se protéger']},
    ]


    let IorE = 
      mbtiList.find(function(data){return data.name === "I"}).count >
      mbtiList.find(function(data){return data.name === "E"}).count  ? 'I':'E'
    let SorN = 
      mbtiList.find(function(data){return data.name === "S"}).count >
      mbtiList.find(function(data){return data.name === "N"}).count  ? 'S':'N'
    let ForT = 
      mbtiList.find(function(data){return data.name === "F"}).count >
      mbtiList.find(function(data){return data.name === "T"}).count  ? 'F':'T'
    let PorJ = 
      mbtiList.find(function(data){return data.name === "P"}).count >
      mbtiList.find(function(data){return data.name === "J"}).count  ? 'P':'J'

    let mbti = IorE + SorN + ForT + PorJ

    setMbtiContents(mc.filter(val=>val.mbti === mbti)[0])
  }

  return (
    <div className="mbtilayout">
      {page === 0? 
        <div className='startPageLayout'>
          <div className='startLogo'>
            <div>MBIT</div>
            <div>▼</div>
          </div>
          <div onClick={()=>{setPage(1)}} className='startButton'>COMMENCER LE TEST</div>
        </div>
      :page <= questionsList.length?
        <div className='questionLayout'>
          <div className='mbtiTitle'> 
            <div>MBTI TEST</div>
            <div>{`${page} / ${questionsList.length}`}</div>
          </div>

          {questionsList.map((val, index)=>{
            return (
              <div className='questionList' style={{display:page===index+1?'flex':'none'}} key={index}>
                {console.log(mbtiList)}
                <div className='questionItemLayout'>
                  <div className='profileImg'>
                    <div/> <div/>
                  </div>
                  <div className='chatListLayout'>
                    {val.q.map((qval, qindex)=>{
                      return (
                        <div key={qindex} className="chatBox">
                          <div>◀</div> <div>{qval}</div>
                        </div>
                      )
                    })}
                  </div>
                </div>
                <div className='answerItemLayout'>
                  <div className='aChatBox'>
                    <div>+</div> <div>#</div>
                  </div>

                    {val.a.map((aval, aindex)=>{
                      return(
                        <div key={aindex} className='answerBox' onClick={()=>handleCkAnswer(aval.type, index)}>
                          {aval.text}
                        </div>
                      )
                    })}
                </div>
              </div>
            )
          })}
        </div>
      :
      <div className='questionLayout'>
        <div className='mbtiTitle'> 
            <div>MBTI TEST</div>
            <div onClick={()=>window.location.reload()}>RECOMMENCER</div>
          </div>

          <div className='questionList' style={{display:'flex'}}>
            <div className='questionItemLayout'>
              <div className='profileImg'>
                <div/> <div/>
              </div>
              <div className='chatListLayout'>
                <div className="chatBox">
                  <div>◀</div> <div>Votre MBTI est {mbtiContents.mbti}.</div>
                </div>
                <div className="chatBox">
                  <div>◀</div> <div>{mbtiContents.mbti} est,</div>
                </div>

                {mbtiContents.contents.map((val,index)=>{
                  return(
                    <div className="chatBox" key={index}>
                      <div>◀</div> <div>{val}</div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default App;
